module.exports = __webpack_public_path__ + "8c24ab4f8fdb9a3c67b28a7f34be52f8.svg";